import { IndicatorEmultiStatusEnum } from "./enums/IndicatorEmultiStatusEnum";

export enum IndicatorEmultiEnum {
	M1 = 1,
	M2 = 2,
}

type IndicatorClassification = {
	awesome: number;
	good: number;
	enough: number;
	regular: number;
	limit: number;
};

const indicatorsClassification: Record<IndicatorEmultiEnum, IndicatorClassification> = {
	[IndicatorEmultiEnum.M1]: { limit: 100, awesome: 3, good: 2, enough: 1, regular: 0 },
	[IndicatorEmultiEnum.M2]: { limit: 100, awesome: 5, good: 2.5, enough: 1, regular: 0 },
};

export function getIndicatorClassificationScores(indicator: IndicatorEmultiEnum) {
	return indicatorsClassification[indicator];
}

export function getIndicatorClassification(indicator: IndicatorEmultiEnum, percentage: number) {
	if (percentage > indicatorsClassification[indicator].limit) return "Regular";
	if (percentage > indicatorsClassification[indicator].awesome) return "Ótimo";
	if (percentage > indicatorsClassification[indicator].good) return "Bom";
	if (percentage > indicatorsClassification[indicator].enough) return "Suficiente";
	return "Regular";
}

export function getIndicatorClassificationColorClassName(
	indicator: IndicatorEmultiEnum,
	percentage: number
) {
	if (percentage > indicatorsClassification[indicator].limit) return "danger";
	if (percentage > indicatorsClassification[indicator].awesome) return "primary";
	if (percentage > indicatorsClassification[indicator].good) return "success";
	if (percentage > indicatorsClassification[indicator].enough) return "warning";
	return "danger";
}

export function getCitizenScoreStatusDescriptionIndicatorEmulti(
	citizenScoreStatus: IndicatorEmultiStatusEnum
) {
	switch (citizenScoreStatus) {
		case IndicatorEmultiStatusEnum.Finished:
			return "Realizado";
		case IndicatorEmultiStatusEnum.Pending:
			return "Pendente";
		case IndicatorEmultiStatusEnum.Lost:
			return "Fora do prazo";
		default:
			return "";
	}
}

export function getIndicatorClassificationColorClassNameByStatus(
	status: IndicatorEmultiStatusEnum
) {
	if (status === IndicatorEmultiStatusEnum.Finished) return "success";
	if (status === IndicatorEmultiStatusEnum.Pending) return "warning";
	return "danger";
}
